module.exports = __webpack_public_path__ + "static/media/wheel-chair.2225e40e.svg";